import { z } from 'zod';

export const labelFieldType = z.enum([
  'String',
  'Double',
  'Currency',
  'Date',
  'CurrentDate',
  'Time',
]);

export const labelField = z.object({
  name: z.string().trim().min(1),
  type: labelFieldType,
  required: z.boolean(),
  text: z.string(),
  initialValue: z.string().optional(),
  inputFormat: z.string().optional(),
  allowedCharacters: z.string().optional(),
  length: z.number().optional(),
  fixedLength: z.boolean().optional(),
  pickListValues: z.array(z.string()).optional(),
  minimumValue: z.string().optional(),
  maximumValue: z.string().optional(),
});

export const labelVariable = z.discriminatedUnion('type', [
  z.object({ name: z.string(), type: z.literal(labelFieldType.enum.String), value: z.string() }),
  z.object({
    name: z.string(),
    type: z.literal(labelFieldType.enum.Double),
    value: z.coerce.number(),
  }),
  z.object({ name: z.string(), type: z.literal(labelFieldType.enum.Time), value: z.string() }),
  z.object({ name: z.string(), type: z.literal(labelFieldType.enum.Currency), value: z.string() }),
  z.object({ name: z.string(), type: z.literal(labelFieldType.enum.Date), value: z.string() }),
  z.object({
    name: z.string(),
    type: z.literal(labelFieldType.enum.CurrentDate),
    value: z.string(),
  }),
]);

export const labelVariableList = z.array(labelVariable);

export const labelRevision = z.object({
  revision: z.string(),
  width: z.number(),
  height: z.number(),
  preview: z.string().nullable(),
  fields: z.array(labelField),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const label = z.object({
  id: z.number().optional(),
  name: z.string(),
  description: z.string().nullable(),
  externalId: z.number(),
  externalPath: z.string(),
  availableRevisions: z.array(z.string()),
  activeRevisions: z.array(z.string()),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});

export const labelAndRevision = z.object({
  label: label,
  revision: labelRevision,
});

export type Label = z.infer<typeof label>;
export type LabelField = z.infer<typeof labelField>;
export type LabelRevision = z.infer<typeof labelRevision>;
export type LabelAndRevision = z.infer<typeof labelAndRevision>;
export type LabelAndRevisionList = { label: Label; revisions: LabelRevision[] };
